<!--
 * @Author: lzh
 * @Date: 2021-07-29 11:57:18
 * @LastEditors: lzh
 * @LastEditTime: 2021-07-30 14:24:34
 * @Description: file content
-->
<template>
  <div class="area-box">
    <!-- 按鈕 -->
    <div
      class="country-box"
      @click="countrySelect"
      @blur="countryBlur"
      tabindex="0"
      v-if="countryData.length > 0"
    >
      <img class="country" :src="countryData[countryIndex].imgUrl" />
      <div>+{{ countryData[countryIndex].code }}</div>
      <van-icon name="arrow-down" size="10" />
    </div>
    <!-- 地區選擇 -->
    <div
      class="login-country-box"
      :style="`max-height:${maxHeight}px;min-width:${minWidth};top:${top};`"
      v-if="countryData.length > 0"
    >
      <van-cell
        v-for="(item, index) in countryData"
        :key="index"
        :title="item.name"
        :icon="item.imgUrl"
        :value="`+${item.code}`"
        class="login-country-line"
        clickable
        @click="selectCountry(index)"
      />
    </div>
  </div>
</template>

<script>
import util from "@/js/util";
export default {
  name: "area-code",
  props: {},
  data() {
    return {
      // 區域數據
      countryData: [
        {
          id: 1,
          name: "香港",
          code: 852,
          domainName: "HK",
          imgUrl:
            "https://ricepon.oss-cn-hongkong.aliyuncs.com//images/member//customize-brand-1/202105/1620454708585.png",
          updateTime: 1592537286000,
          isDelete: 1
        },
        {
          id: 4,
          name: "新加坡",
          code: 65,
          domainName: "SGP",
          imgUrl:
            "https://ricepon.oss-cn-hongkong.aliyuncs.com//images/member//customize-brand-1/202105/1620454736873.png",
          updateTime: 1592537285000,
          isDelete: 1
        },
        {
          id: 2,
          name: "澳門",
          code: 853,
          domainName: "MO",
          imgUrl:
            "https://ricepon.oss-cn-hongkong.aliyuncs.com//images/member//customize-brand-1/202105/1620454723552.png",
          updateTime: 1573116214000,
          isDelete: 1
        },
        {
          id: 3,
          name: "中國大陸",
          code: 86,
          domainName: "CN",
          imgUrl:
            "https://ricepon.oss-cn-hongkong.aliyuncs.com//images/member//customize-brand-1/202105/1620454673185.png",
          updateTime: 1573116214000,
          isDelete: 1
        }
      ],
      // 當前選中
      countryIndex: 0,
      maxHeight: 0,
      minWidth: "0px",
      top: "0px"
    };
  },
  mounted() {
      if (this.country && this.country.length > 0) {
        this.countryData = this.country || []
      }

      // 回調一下
      this.$emit("change", this.countryData[this.countryIndex]);
    let o = document.querySelector(".area-box");
    let p = o.parentElement;
    let width = util.getStyle(p, "width");
    this.minWidth = width;
    this.top = util.getStyle(p, "height");
  },
  methods: {
    // 點擊 選擇地區
    countrySelect() {
      this.maxHeight = 500;
    },
    // 地區失去焦點, 自動隱藏
    countryBlur() {
      this.maxHeight = 0;
    },
    // 選擇了 區域
    selectCountry(index) {
      this.maxHeight = 0;
      this.countryIndex = index;
      this.$emit("change", this.countryData[index]);
    }
  }
};
</script>

<style lang="less" scoped>
.area-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .country-box {
    display: flex;
    align-items: center;
    padding-right: 10px;
    outline: none;
    .country {
      width: 35px;
      height: 23px;
      box-shadow: 1px 0px 2px 0px rgba(0, 0, 0, 0.1);
      margin-right: 10px;
    }
    div {
      font-size: 15px;
      color: rgba(51, 51, 51, 1);
      margin-right: 5px;
    }
  }
  .login-country-box {
    position: absolute;
    width: 100%;
    top: 33px;
    z-index: 20;
    left: 0;
    background: #fff;
    box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 8px 8px;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s;
    .login-country-line {
      img {
        width: 35px;
        height: 23px;
        -webkit-box-shadow: 1px 0px 2px 0px rgba(0, 0, 0, 0.1);
        box-shadow: 1px 0px 2px 0px rgba(0, 0, 0, 0.1);
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/areaCode.vue